import { render, staticRenderFns } from "./SupportChatsList.vue?vue&type=template&id=0d5c4450&scoped=true"
import script from "./SupportChatsList.vue?vue&type=script&lang=js"
export * from "./SupportChatsList.vue?vue&type=script&lang=js"
import style0 from "./SupportChatsList.vue?vue&type=style&index=0&id=0d5c4450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5c4450",
  null
  
)

export default component.exports